import { render, staticRenderFns } from "./previewModal.vue?vue&type=template&id=ed910a18&scoped=true"
import script from "./previewModal.vue?vue&type=script&lang=js"
export * from "./previewModal.vue?vue&type=script&lang=js"
import style0 from "./previewModal.vue?vue&type=style&index=0&id=ed910a18&prod&lang=scss"
import style1 from "./previewModal.vue?vue&type=style&index=1&id=ed910a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed910a18",
  null
  
)

export default component.exports